import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import {
  setExternalPlatformFilter,
  setExternalSentimentFilter,
  setSelectedTab,
} from '@/store/api/DigitalReport/digitalReport.slice'
import {
  FilterByTypeEnum,
  PlatformTypes,
} from '@/store/api/Person/Person.types'

import { TotalPostsCard } from './TotalPostsCard'

interface ContentSummaryWidgetTypes {
  positivePosts: number
  negativePosts: number
  flaggedPosts: number
  webSearchPosts: number
}

export const ContentSummaryWidget = ({
  negativePosts,
  positivePosts,
  flaggedPosts,
  webSearchPosts,
}: ContentSummaryWidgetTypes) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const handleTrackEvent = (postType: string) => {
    dispatch(setSelectedTab('posts'))

    const filterBy =
      postType === 'Negative'
        ? FilterByTypeEnum.NEGATIVE
        : postType === 'Positive'
          ? FilterByTypeEnum.POSITIVE
          : FilterByTypeEnum.FLAGGED
    dispatch(setExternalPlatformFilter('all'))

    dispatch(setExternalSentimentFilter(filterBy))
  }

  const handleTrackEventWebNews = () => {
    dispatch(setSelectedTab('posts'))
    dispatch(setExternalSentimentFilter('all'))
    dispatch(setExternalPlatformFilter(PlatformTypes.WEBSEARCH))
  }

  return (
    <div className="flex gap-5 flex-wrap justify-center max-md:h-full">
      <TotalPostsCard
        sentiment={t('report.posts.flaggedPosts')}
        onClick={() => handleTrackEvent('Flagged')}
        totalPosts={flaggedPosts}
        isFlagged
      />
      <TotalPostsCard
        sentiment={t('report.posts.negativePosts')}
        onClick={() => handleTrackEvent('Negative')}
        totalPosts={negativePosts}
      />
      <TotalPostsCard
        sentiment={t('report.posts.positivePosts')}
        onClick={() => handleTrackEvent('Positive')}
        totalPosts={positivePosts}
      />
      <TotalPostsCard
        sentiment={t('report.posts.webNews')}
        onClick={() => handleTrackEventWebNews()}
        totalPosts={webSearchPosts}
      />
    </div>
  )
}
